import { isMicrofrontendOrigin, resolveMicrofrontendOrigin } from './microfrontend-origins.js'

const env = import.meta.env ?? {}

const getConfiguredOrigin = (microfrontend) => {
  try {
    return resolveMicrofrontendOrigin(microfrontend, env)
  } catch {
    return null
  }
}

export const microfrontends = {
  certificados: {
    label: 'Certificados de Cobertura',
    basePath: '/certificados',
    defaultPath: '/renovaciones',
    resolvedPath: '/certificados',
    menuPath: '/certificados',
    menuAliases: ['/certificados-cobertura', '/certificados-cobertura/renovaciones'],
    standalonePaths: ['/renovaciones'],
    load: () => import('certificados/RemoteApp'),
  },
  nomina: {
    label: 'Nómina',
    basePath: '/nomina',
    defaultPath: '/',
    menuPath: '/nomina',
    menuAliases: ['/nomina-trabajadores', '/trabajadores/nomina'],
    standalonePaths: ['/'],
    load: () => import('nomina/RemoteApp'),
  },
  informes: {
    label: 'Informes',
    basePath: '/informe-siniestralidad',
    defaultPath: '/',
    menuPath: '/informe-siniestralidad',
    menuAliases: ['/informes-siniestralidad', '/informes', '/informes-ingenieria-siniestralidad'],
    standalonePaths: ['/'],
    load: () => import('informes/RemoteApp'),
  },
  credenciales: {
    label: 'Credenciales',
    basePath: '/credenciales',
    defaultPath: '/',
    menuPath: '/credenciales',
    menuAliases: ['/impresion-credenciales'],
    standalonePaths: ['/', '/credenciales'],
    load: () => import('credenciales/RemoteApp'),
  },
  'administracion-usuario': {
    label: 'Administración de usuarios',
    basePath: '/administracion-usuarios',
    defaultPath: '/',
    menuPath: '/administracion-usuarios',
    menuAliases: [],
    standalonePaths: ['/'],
    load: () => import('administracion-usuario/RemoteApp'),
  },
  'informe-cancerigeno': {
    label: 'Informe Cancerígeno',
    basePath: '/informe-cancerigeno',
    defaultPath: '/',
    menuPath: '/informe-cancerigeno',
    menuAliases: [],
    standalonePaths: ['/'],
    load: () => import('informe-cancerigeno/RemoteApp'),
  },
  rar: {
    label: 'RAR',
    basePath: '/rar',
    defaultPath: '/',
    menuPath: '/rar',
    menuAliases: [],
    standalonePaths: ['/'],
    load: () => import('rar/RemoteApp'),
  },
}

export function resolveMicrofrontendPath(rawUrl) {
  if (!rawUrl) return null

  for (const app of Object.values(microfrontends)) {
    const menuPaths = [app.menuPath, ...(app.menuAliases ?? [])]
    if (menuPaths.includes(rawUrl)) {
      return app.resolvedPath ?? `${app.basePath}${app.defaultPath}`
    }
  }

  try {
    const url = new URL(rawUrl)
    const pathname = url.pathname.replace(/\/$/, '') || '/'

    for (const [name, app] of Object.entries(microfrontends)) {
      const matchesOrigin = isMicrofrontendOrigin(name, url.origin, getConfiguredOrigin(name))
      if (matchesOrigin && app.standalonePaths.includes(pathname)) {
        return app.resolvedPath ?? `${app.basePath}${app.defaultPath}`
      }
    }
  } catch {
    return null
  }

  return null
}
